import * as THREE from 'three';
import { EARTH_GEOMETRY, EARTH_MATERIAL, EARTH_POSITION } from './constants';

/**
 * Creates and returns an Earth object with texture
 */
const createEarth = () => {
  // Create Earth
  const earthGeometry = new THREE.SphereGeometry(
    EARTH_GEOMETRY.RADIUS, 
    EARTH_GEOMETRY.SEGMENTS, 
    EARTH_GEOMETRY.SEGMENTS
  );
  
  // Create textured earth material using earth_texture.jpg
  const textureLoader = new THREE.TextureLoader();
  // Use correct path to the image
  const earthTexture = textureLoader.load('img/earth_texture.jpg');
  const earthMaterial = new THREE.MeshPhongMaterial({
    map: earthTexture,
    shininess: EARTH_MATERIAL.SHININESS,
    specular: EARTH_MATERIAL.SPECULAR
  });
  
  // Create an earth group to contain earth
  const earthGroup = new THREE.Group();
  // Position earth at left third of the scene
  earthGroup.position.set(
    EARTH_POSITION.X, 
    EARTH_POSITION.Y, 
    EARTH_POSITION.Z
  );
  
  // Create the earth mesh and add it to the group
  const earth = new THREE.Mesh(earthGeometry, earthMaterial);
  earthGroup.add(earth);
  
  return { 
    earthGroup,
    earthGeometry,
    earthMaterial,
    earth
  };
};

/**
 * Cleanup function for Earth objects
 */
const cleanupEarth = (scene, { earthGroup, earthGeometry, earthMaterial }) => {
  scene.remove(earthGroup);
  earthGeometry.dispose();
  earthMaterial.dispose();
};

export { createEarth, cleanupEarth };